import { motion, useReducedMotion } from 'motion/react'
import clsx from 'clsx'
import { useId } from 'react'
import getStoryProgressIndicators from './getStoryProgressIndicators'
import styles from './StoryProgress.module.css'

export interface StoryProgressProps {
	storyIndex: number
	storyCount: number
}

export default function StoryProgress({ storyIndex, storyCount }: StoryProgressProps) {
	const activeDotLayoutId = useId()
	const indicators = getStoryProgressIndicators(storyCount, storyIndex)
	const prefersReducedMotion = useReducedMotion()

	return (
		<div
			className={styles.progress}
			aria-label={`第 ${storyIndex + 1} 条，共 ${storyCount} 条日记`}
		>
			{indicators.map((indicator) => (
				<motion.span
					key={indicator.index}
					className={clsx(
						styles.progressDot,
						indicator.active && styles.activeProgressDotContainer
					)}
					aria-hidden="true"
					initial={false}
					animate={{ scale: indicator.condensed ? 0.625 : 1 }}
					transition={prefersReducedMotion ? { duration: 0 } : { duration: 0.16, ease: 'easeOut' }}
				>
					{indicator.active && (
						<motion.span
							className={styles.activeProgressDot}
							layoutId={prefersReducedMotion ? undefined : activeDotLayoutId}
							transition={{ type: 'spring', stiffness: 500, damping: 36, mass: 0.7 }}
						/>
					)}
				</motion.span>
			))}
		</div>
	)
}
